module.exports = __webpack_public_path__ + "static/img/choice.4f656be9.svg";